"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setItem = exports.getItem = void 0;
var setItem = exports.setItem = function setItem(key, value) {
  if (!global.localStorage) {
    return;
  }
  var stringifiedValue = JSON.stringify(value);
  global.localStorage.setItem("api-console:".concat(key), stringifiedValue); // NOSONAR
};
var getItem = exports.getItem = function getItem(key) {
  if (!global.localStorage) {
    return null;
  }
  var item = global.localStorage.getItem("api-console:".concat(key)); // NOSONAR

  if (!item) {
    return null;
  }
  try {
    return JSON.parse(item);
  } catch (error) {
    return null;
  }
};
//# sourceMappingURL=localStorage.js.map